import React from 'react'
import {Row, Col, Icon, Button} from 'antd';
import isEqual from 'lodash/isEqual';
import "./style/index.less";
import commonAppImg from '../../../style/img/commonApp.png';
import util from '../../../util';
const { isWeaver } = util;
const isweaver = isWeaver();
class App extends React.Component {

  static defaultProps = {
    previewDisable: false
  }

  constructor(props) {
    super(props);
    this.state = {
      showCollect: [false, false, false, false, false, false],
      showDropdown: false,
      data: this.props.data || [],
      isSmallScreen: false,
    }
  }

  componentDidMount() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillReceiveProps(nextProps) {
    const { data } = this.state;
    if (nextProps.data && !isEqual(nextProps.data, data)) {
      this.setState({data: nextProps.data});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  resizeHandler = () => {
    const cWidth = document.clientWidth || document.documentElement.clientWidth;
    const sWidth = document.scrollWidth || document.documentElement.scrollWidth;
    const docWidth = Math.max(cWidth, sWidth);
    this.setState({ isSmallScreen: docWidth <= 1120 }); // 小屏宽度暂定1120px
  }

  getSmallCard = (item, index) => {
    const server = window.server || '';
    const prefixCls = 'cards-sub-content-small';
    const { onCollect, onOpen, onApply, allApp, previewDisable } = this.props;
    return (
      <Col span={allApp ? 6 : 8} className={`cards-col ${(index < 3 || allApp) ? 'cards-col-small' : 'cards-col2-small'}`} key={item.key}>
        <div className={prefixCls}>
          <div className={`${prefixCls}-mask`} />
          <img onError={(e) => { e.target.onerror = null; e.target.src = commonAppImg; }} src={`${item.s_pictureNati ? server + item.s_pictureNati : commonAppImg }`} alt=''/>
          <div className={`${prefixCls}-con`}>
              <div className={`${prefixCls}-con-collect`} onClick={(e) => {
                  isweaver && typeof onCollect === 'function' && onCollect(item)
                  e.stopPropagation && e.stopPropagation();
                  e.preventDefault && e.preventDefault();
                  e.nativeEvent && e.nativeEvent.preventDefault();
                }}>
                  { isweaver ? item.tms_iscoll === '1' ? (<Icon type="star" />) : (<Icon type="star" theme="filled" style={{ color: '#1e94ff' }} />) : <div style={{ height: 15 }}/>}
                  { isweaver && (<span>{item.tms_iscoll === '1' ? '收藏' : '取消收藏'}</span>) }
                </div>
            <div className={`${prefixCls}-name cards-text-elli`} title={item.s_name}>{item.s_name}</div>
            <div className={`${prefixCls}-con-btn`}>
              <Button type="primary" style={previewDisable ? {cursor:'not-allowed'} : {}} onClick={() => typeof onOpen === 'function' && !previewDisable && onOpen(item)}>预览</Button>
              <Button disabled={!isweaver} onClick={() => typeof onApply === 'function' && onApply(item)}>申请</Button>
            </div>
          </div>
        </div>
      </Col>
    )
  }

  render() {
    const server = window.server;
    let {showCollect, data, isSmallScreen } = this.state;
    const {
      mainImg, collect = false, onCollect
      , onClick, onApply, onOpen, needView = true, allApp, previewDisable
    } = this.props;
    const iconStyle = {
      fontSize: '100px',
      color: '#666',
      textAlign: 'center',
      marginBottom: '10px',
    }
    return (
      <div className='cards'>
        {
        !allApp && 
          <div className='cards-main-image'>
            <img src={mainImg} alt=''/>
          </div>
        }
        <div className='cards-main' style={allApp ? {paddingLeft: "0px", position: "static", margin: 0} : {}}>
          <Row className='cards-main-content' style={allApp ? {marginLeft: "-14px"} : {}}>
            {
              data.map((item, index) => {
                if (isSmallScreen) return this.getSmallCard(item, index);
                return (
                  <Col span={allApp ? 6 : 8} className={`cards-col ${(index < 3 || allApp) && 'cards-col2'}`}
                       key={item.key}>
                    <div className='cards-sub'
                         onMouseOver={(e) => {
                           showCollect[index] = true;
                           this.setState({showCollect: showCollect});
                           e.stopPropagation && e.stopPropagation();
                           e.preventDefault && e.preventDefault();
                           e.nativeEvent && e.nativeEvent.preventDefault();
                         }}
                         onMouseOut={(e) => {
                           showCollect[index] = false;
                           this.setState({showCollect: showCollect, showDropdown: false});
                           e.stopPropagation && e.stopPropagation();
                           e.preventDefault && e.preventDefault();
                           e.nativeEvent && e.nativeEvent.preventDefault();
                         }}
                         onClick={(e) => {
                           !previewDisable && typeof onClick === 'function' && onClick(item);
                           e.stopPropagation && e.stopPropagation();
                           e.preventDefault && e.preventDefault();
                           e.nativeEvent && e.nativeEvent.preventDefault();
                         }}
                    >
                      <div className='cards-sub-img'>
                        <img onError={(e) => { e.target.onerror = null; e.target.src = commonAppImg; }} src={`${item.s_pictureNati ? server + item.s_pictureNati : commonAppImg }`} alt=''/>
                      </div>
                      <div className='cards-sub-content'>
                        <Row>
                          <Col span={24}>
                            <div className='cards-sub-content-name'
                                 style={{paddingBottom: 18}}
                                 title={item.s_name}>{item.s_name}</div>
                            <div className='cards-sub-content-num'
                                 title={`使用次数：${item.tms_isbuy_count}次`}>使用次数:&nbsp;&nbsp;
                              <span style={{fontSize: 18, color: '#449af8'}}>{item.tms_isbuy_count}</span>次
                            </div>
                          </Col>
                        </Row>
                      </div>
                      {
                        collect && (
                          <div className='collect1'
                               hidden={!showCollect[index]}
                               onClick={(e) => {
                                 typeof onCollect === 'function' && onCollect(item)
                                 e.stopPropagation && e.stopPropagation();
                                 e.preventDefault && e.preventDefault();
                                 e.nativeEvent && e.nativeEvent.preventDefault();
                               }}
                          >
                            <Icon type="star-o" className='icon-star'/>
                            <div className='collect-text'><span>收藏</span></div>
                          </div>
                        )
                      }
                      {
                        !collect && (
                          <div className='collect2' hidden={!showCollect[index]}>
                            <div className='collect2-btns'>
                              {
                                needView && (
                                  <span
                                    className='collect2-btn'
                                    style={previewDisable ? {cursor:'not-allowed'} : {}} 
                                    onClick={(e) => {
                                      typeof onOpen === 'function' && !previewDisable && onOpen(item);
                                      e.stopPropagation && e.stopPropagation();
                                      e.preventDefault && e.preventDefault();
                                      e.nativeEvent && e.nativeEvent.preventDefault();
                                  }}>预览</span>
                                )
                              }
                              <span className={`collect2-btn ${!isweaver && 'cs-btn-disabled'}`}
                                    onClick={(e) => {
                                      isweaver && typeof onApply === 'function' && onApply(item);
                                      e.stopPropagation && e.stopPropagation();
                                      e.preventDefault && e.preventDefault();
                                      e.nativeEvent && e.nativeEvent.preventDefault();
                                    }}>申请</span>
                              <span className={`collect2-btn ${!isweaver && 'cs-btn-disabled'}`}
                                    onClick={(e) => {
                                      isweaver && typeof onCollect === 'function' && onCollect(item);
                                      e.stopPropagation && e.stopPropagation();
                                      e.preventDefault && e.preventDefault();
                                      e.nativeEvent && e.nativeEvent.preventDefault();
                                    }}>
                                {item.tms_iscoll === '1' ? '收藏' : '取消收藏'}
                              </span>
                              {/*<Icon type="minus" className='collect2-icon'/>*/}
                              {/*<span className='collect2-btn' onMouseOver={(e) => {*/}
                              {/*this.setState({showDropdown: true});*/}
                              {/*}} style={{width: 80}}>*/}
                              {/*添加至 <Icon type="down"/>*/}
                              {/*</span>*/}
                              {/*<div className='collect2-dropdown-con'*/}
                              {/*onMouseOver={(e) => {*/}
                              {/*this.setState({showDropdown: true});*/}
                              {/*}}*/}
                              {/*onMouseOut={(e) => {*/}
                              {/*this.setState({showDropdown: false});*/}
                              {/*}}*/}
                              {/*>*/}
                              {/*<div className='collect2-dropdown'>*/}
                              {/*<ul hidden={!showDropdown}>*/}
                              {/*<li key="1"*/}
                              {/*onClick={(e) => {*/}
                              {/*typeof onCollect === 'function' && onCollect(item);*/}
                              {/*e.stopPropagation && e.stopPropagation();*/}
                              {/*e.preventDefault && e.preventDefault();*/}
                              {/*e.nativeEvent && e.nativeEvent.preventDefault();*/}
                              {/*}}>我的收藏*/}
                              {/*</li>*/}
                              {/*/!*<li key="2">我的项目</li>*!/*/}
                              {/*/!*<li key="3">我的方案</li>*!/*/}
                              {/*</ul>*/}
                              {/*</div>*/}
                              {/*</div>*/}
                            </div>
                          </div>
                        )
                      }
                    </div>
                  </Col>
                )
              })
            }
          </Row>
        </div>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/cards/index.js